import type {
  UserActivationApi,
  UserActivationBrowserOpenOptions,
} from '@hibro/shared';
import { normalizeBrowserUrl } from '@hibro/shared';

export function createWebUserActivationApi(runtime: {
  openBrowserWindow(
    url: string,
    options: UserActivationBrowserOpenOptions,
  ): boolean;
}): UserActivationApi {
  return {
    openBrowser(options) {
      try {
        if (options.presentation !== 'window') {
          throw new Error(
            'User-activated browser opening requires window presentation',
          );
        }
        if (options.partition === 'ephemeral') {
          throw new Error(
            'Web built-in browser does not support ephemeral storage partitions',
          );
        }
        const url = normalizeBrowserUrl(options.url);
        if (!runtime.openBrowserWindow(url, options)) {
          throw new Error(
            'The browser blocked the independent window; allow popups and try again',
          );
        }
        return Promise.resolve();
      } catch (error: unknown) {
        return Promise.reject(
          error instanceof Error ? error : new Error(String(error)),
        );
      }
    },
  };
}
